import { StandardEvents } from '@shopify/events';

class FeaturedVariantProducts extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const { signal } = this.#abortController;

    this.addEventListener('click', this.#handleClick, { signal });
    this.addEventListener('keydown', this.#handleKeydown, { signal });
    this.addEventListener(StandardEvents.cartLinesUpdate, this.#handleCartUpdate, { signal });
  }

  disconnectedCallback() {
    this.#abortController.abort();
  }

  #handleClick = (event) => {
    const filter = event.target.closest('[data-variant-filter]');
    if (filter) {
      this.#filterCards(filter);
      return;
    }

    const card = event.target.closest('[data-variant-card-url]');
    if (!card || event.target.closest('a, button, form, input, select, textarea')) return;

    window.location.assign(card.dataset.variantCardUrl);
  };

  #handleKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const card = event.target.closest('[data-variant-card-url]');
    if (!card || event.target !== card) return;

    event.preventDefault();
    window.location.assign(card.dataset.variantCardUrl);
  };

  #filterCards(button) {
    const selectedFilter = button.dataset.variantFilter;

    for (const filterButton of this.querySelectorAll('[data-variant-filter]')) {
      const isSelected = filterButton === button;
      filterButton.classList.toggle('is-active', isSelected);
      filterButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    }

    for (const card of this.querySelectorAll('[data-variant-card]')) {
      card.hidden = selectedFilter !== 'all' && card.dataset.variantCard !== selectedFilter;
    }
  }

  #handleCartUpdate = (event) => {
    if (!(event.target instanceof Element) || !this.contains(event.target) || event.action !== 'add') return;

    event.promise
      ?.then(({ detail }) => {
        if (detail?.didError) return;

        const drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[featured-variant-products] Cart drawer open failed:', error);
      });
  };
}

if (!customElements.get('featured-variant-products')) {
  customElements.define('featured-variant-products', FeaturedVariantProducts);
}
